/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EcommerceUserApiResponseVo } from './EcommerceUserApiResponseVo';
import {
    EcommerceUserApiResponseVoFromJSON,
    EcommerceUserApiResponseVoFromJSONTyped,
    EcommerceUserApiResponseVoToJSON,
    EcommerceUserApiResponseVoToJSONTyped,
} from './EcommerceUserApiResponseVo';

/**
 * 
 * @export
 * @interface ResponseEcommerceUserApiResponseVo
 */
export interface ResponseEcommerceUserApiResponseVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseEcommerceUserApiResponseVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseEcommerceUserApiResponseVo
     */
    message?: string;
    /**
     * 
     * @type {EcommerceUserApiResponseVo}
     * @memberof ResponseEcommerceUserApiResponseVo
     */
    data?: EcommerceUserApiResponseVo;
}

/**
 * Check if a given object implements the ResponseEcommerceUserApiResponseVo interface.
 */
export function instanceOfResponseEcommerceUserApiResponseVo(value: object): value is ResponseEcommerceUserApiResponseVo {
    return true;
}

export function ResponseEcommerceUserApiResponseVoFromJSON(json: any): ResponseEcommerceUserApiResponseVo {
    return ResponseEcommerceUserApiResponseVoFromJSONTyped(json, false);
}

export function ResponseEcommerceUserApiResponseVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseEcommerceUserApiResponseVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : EcommerceUserApiResponseVoFromJSON(json['data']),
    };
}

export function ResponseEcommerceUserApiResponseVoToJSON(json: any): ResponseEcommerceUserApiResponseVo {
    return ResponseEcommerceUserApiResponseVoToJSONTyped(json, false);
}

export function ResponseEcommerceUserApiResponseVoToJSONTyped(value?: ResponseEcommerceUserApiResponseVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': EcommerceUserApiResponseVoToJSON(value['data']),
    };
}

